<template>
    <nav class="w-full h-auto z-10 flex items-start justify-between py-1 px-3">
        <RouterLink to="/" v-if="!$route.meta.public" class="flex items-center flex-shrink-0 text-white">
            <img :class="brand.logoClass" :src="brand.logo" :alt="brand.name" />
        </RouterLink>
        <div v-else class="flex items-center flex-shrink-0 text-white">
            <img :class="brand.logoClass" :src="brand.logo" :alt="brand.name" />
        </div>
        <div class="flex items-right flex-shrink-0" v-if="!$route.meta.public">
            <button @click="toggleSidebar" class="lg:inline-block lg:mt-0 mr-4">
                <i class="fas fa-bars text-xl fa-2x text-white"></i>
            </button>            
        </div>
    </nav>    

</template>

<script>
import { collapsed, toggleSidebar, sidebarWidth } from './state'
import brand from '@/config/branding';
export default {
    data() {
        return{
            show: false,
            brand,
        }
    },
    setup() {
        return { collapsed, toggleSidebar, sidebarWidth }
    },
    async mounted(){        

    }
};
</script>
<style scoped>
.dropdown__menu {
top: 100%;
right: 0;
position: absolute;
z-index: 9999;
height: auto;
min-width: 300px;
margin-top: 1rem;
overflow-y: auto;
padding: 1rem 1rem 1rem 0rem;
border-radius: 12px;
background-color: white;
border: 1px solid var(--color-gray);
background-clip: padding-box;
}
.dropdown__menu-link {
display: flex;
align-items: center;
justify-content: flex-start;
text-decoration: none;
color: rgba(var(--rgb-brandlight), 0.6);
padding: 0.8rem 0 0.8rem 2rem;
margin-top: 0.2rem;
margin-bottom: 0.2rem;
border-radius: 0 50px 50px 0;
}
.dropdown__menu-link:hover {
background-color: rgba(var(--rgb-brandlight), 0.5);
}
.slide-fade-enter-active, .slide-fade-leave-active {
transition: all 0.6s;
}
.slide-fade-enter, .slide-fade-leave-active {
opacity: 0;
}
.slide-fade-enter {
transform: translateX(31px);
}
.slide-fade-leave-active {
transform: translateX(-31px);
}
.status-label {
color: var(--brand-status-text-color);
}
</style>
